<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Detalhes de Usuário</strong>
        </div>
        <b-form @submit.stop.prevent>
          <b-form-group label="Username" label-for="username">
            <b-form-input id="username" v-model="user.username"></b-form-input>
          </b-form-group>
          <b-form-group label="Eventos" label-for="events">
            <b-form-input id="events" type="number" min="1" max="50" v-model="user.events"></b-form-input>
          </b-form-group>
          <div slot="footer">
            <b-row>
              <b-col sm="12" lg="2">
                <b-button class="form-control" type="button" variant="success" @click="find"><i class="fa fa-search"></i> Buscar</b-button>&nbsp;
              </b-col>
            </b-row>
          </div>
        </b-form>
        <div>
          <tree-view v-if="result != null" :data="result" :options="{maxDepth: 3, rootObjectKey: 'cloud'}"></tree-view>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env } from '@/shared/utils';
import { request } from 'http';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading
  },
  data: () => {
    return {
      user: {
        events: 10
      },
      loadCount: 0,
      result: null
    }
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    find() {
      let username = this.user.username && this.user.username.replace(/[^\da-zA-Z]/g, "").toUpperCase();
      if (!username) {
        return alert("Informe um nome de usuário.");
      }
      var _this = this;
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/user-deep-detail/${username}?events=${this.user.events}`)
        .then(function(response) {
          console.log(response);
          _this.result = response.data;
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
  }
}
</script>
